<template>
  <span class="navigation-icon" :class="{ inverse }" aria-hidden="true">
    <!-- The Vino icon for the destination wins; the menu record's own icon is the fallback. -->
    <VnIcon v-if="vinoIcon" :name="vinoIcon" />
    <span v-else-if="maskable" class="mask" :style="maskStyle" />
    <img v-else-if="resolved && !failed" :src="resolved" alt="" @error="failed = true" />
    <VnIcon v-else :name="group ? 'layers' : 'list'" />
  </span>
</template>
<script>
import VnIcon from '../VnIcon/index.vue';
import { menuForRoute, menuIconSource } from '../../utils/adminNavigation';
import { iconForRoute } from '../../utils/vinoIcons';

export default {
  name: 'NavigationIcon',
  components: { VnIcon },
  // `source`: the sidebar passes the state-specific icon. Without it, the icon of the page's
  // menu entry is used and drawn as a mask so it follows the surrounding text colour.
  props: { source: String, route: String, name: String, group: Boolean, inverse: Boolean, leaf: Boolean },
  data() { return { failed: false }; },
  computed: {
    vinoIcon() { return iconForRoute(this.route, this.leaf); },
    resolved() {
      if (this.source) return this.source;
      const menu = this.route ? menuForRoute(this.$STORE.state.appConfig.menu, this.route) : null;
      return menu ? menuIconSource(menu, false) : '';
    },
    maskable() { return !this.source && /^data:image\/svg\+xml/.test(this.resolved || ''); },
    maskStyle() { const url = `url("${this.resolved}")`; return { WebkitMaskImage: url, maskImage: url }; },
  },
  watch: { resolved() { this.failed = false; } },
};
</script>
<style scoped>
.navigation-icon { width: 22px; height: 22px; flex: 0 0 22px; display: inline-flex; align-items: center; justify-content: center; }
.navigation-icon .vn-icon, img, .mask { width: 100%; height: 100%; object-fit: contain; }
.mask { display: block; background: currentColor; -webkit-mask: no-repeat center / contain; mask: no-repeat center / contain; }
/* legacy raster icons are dark artwork: render them light on the navy shell */
.inverse img { filter: brightness(0) invert(1); opacity: .78; }
</style>
